import { Vector2, Vector3 } from "flavr-math";
import { Triangle } from "three";
const asBufferAttribute = (attribute) => {
    return attribute;
};
function getBarycoord(point, a, b, c, target) {
    const _v0 = new Vector2().subVectors(c, a);
    const _v1 = new Vector2().subVectors(b, a);
    const _v2 = new Vector2().subVectors(point, a);
    const dot00 = _v0.dot(_v0);
    const dot01 = _v0.dot(_v1);
    const dot02 = _v0.dot(_v2);
    const dot11 = _v1.dot(_v1);
    const dot12 = _v1.dot(_v2);
    const denom = dot00 * dot11 - dot01 * dot01;
    // collinear or singular triangle
    if (denom === 0) {
        // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
    }
    const invDenom = 1 / denom;
    const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
    const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
    // barycentric coordinates must always sum to 1
    return target.set(1 - u - v, v, u);
}
const tmpVector3_1 = new Vector3();
const tmpVector3_2 = new Vector3();
const tmpVector3_3 = new Vector3();
const tmpVector3_4 = new Vector3();
function calcPointInTriangle(vertexA, vertexB, vertexC, u, v, target) {
    // P = A + u * (C - A) + v * (B - A)
    const ca = tmpVector3_1.subVectors(vertexC, vertexA);
    const uca = tmpVector3_2.copy(ca).multiplyScalar(u);
    const ba = tmpVector3_3.subVectors(vertexB, vertexA);
    const vba = tmpVector3_4.copy(ba).multiplyScalar(v);
    return target.copy(vertexA).add(uca).add(vba);
}
const _vA = new Vector3();
const _vB = new Vector3();
const _vC = new Vector3();
const _uvA = new Vector2();
const _uvB = new Vector2();
const _uvC = new Vector2();
function checkBufferGeometryIntersection(uvCoord, position, uv, a, b, c, targetPoint, targetNormal) {
    _vA.fromBufferAttribute(asBufferAttribute(position), a);
    _vB.fromBufferAttribute(asBufferAttribute(position), b);
    _vC.fromBufferAttribute(asBufferAttribute(position), c);
    _uvA.fromBufferAttribute(asBufferAttribute(uv), a);
    _uvB.fromBufferAttribute(asBufferAttribute(uv), b);
    _uvC.fromBufferAttribute(asBufferAttribute(uv), c);
    const baryTarget = tmpVector3_1;
    getBarycoord(uvCoord, _uvA, _uvB, _uvC, baryTarget);
    const inTriangle = baryTarget.x >= 0 && baryTarget.y >= 0 && baryTarget.x + baryTarget.y <= 1;
    if (!inTriangle) {
        return false;
    }
    calcPointInTriangle(_vA, _vB, _vC, baryTarget.z, baryTarget.y, targetPoint);
    Triangle.getNormal(_vA, _vB, _vC, targetNormal);
    return true;
}
export function findPositionInGeomtryByUV(geomtry, uvCoord, targetPoint, targetNormal) {
    const index = geomtry.index;
    const position = geomtry.attributes.position;
    const uv = geomtry.attributes.uv;
    const drawRange = geomtry.drawRange;
    if (index !== null) {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(index.count, drawRange.start + drawRange.count);
        for (let i = start, il = end; i < il; i += 3) {
            const a = index.getX(i);
            const b = index.getX(i + 1);
            const c = index.getX(i + 2);
            if (checkBufferGeometryIntersection(uvCoord, position, uv, a, b, c, targetPoint, targetNormal)) {
                return;
            }
        }
    }
    else if (position !== undefined) {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(position.count, drawRange.start + drawRange.count);
        for (let i = start, il = end; i < il; i += 3) {
            const a = i;
            const b = i + 1;
            const c = i + 2;
            if (checkBufferGeometryIntersection(uvCoord, position, uv, a, b, c, targetPoint, targetNormal)) {
                return;
            }
        }
    }
}
